// Application constants

/**
 * Default map center coordinates (center of France)
 */
export const DEFAULT_MAP_CENTER: [number, number] = [46.603354, 1.888334];

/**
 * Default map zoom level
 */
export const DEFAULT_MAP_ZOOM = 6;

/**
 * Minimum zoom level for centering on a record
 */
export const MIN_RECORD_ZOOM = 12;

/**
 * Color palette for marker types
 * 10 distinct colors for type differentiation
 */
export const COLOR_PALETTE = [
  '#2E86AB', // Blue
  '#A23B72', // Purple
  '#F18F01', // Orange
  '#C73E1D', // Red
  '#6A994E', // Green
  '#BC4B51', // Crimson
  '#8D5B4C', // Brown
  '#F4A259', // Light orange
  '#5C80BC', // Light blue
  '#B392AC', // Mauve
] as const;

/**
 * Selected marker icon URL
 */
export const SELECTED_MARKER_ICON_URL =
  'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png';

/**
 * OpenStreetMap tile layer URL
 */
export const OSM_TILE_URL = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';

/**
 * OpenStreetMap attribution
 */
export const OSM_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

/**
 * Marker cluster configuration
 */
export const CLUSTER_CONFIG = {
  chunkedLoading: true,
  chunkInterval: 200,
  chunkDelay: 50,
  maxClusterRadius: 80,
  spiderfyOnMaxZoom: true,
  showCoverageOnHover: false,
  zoomToBoundsOnClick: true,
  removeOutsideVisibleBounds: true,
} as const;

import { regionsData, departementsData } from '../data';

/**
 * Geoportail API endpoints and data
 */
export const GEOPORTAIL_API = {
  isochrone: 'https://data.geopf.fr/navigation/isochrone',
} as const;

/**
 * Local GeoJSON data for administrative boundaries
 */
export const BOUNDARY_DATA = {
  regions: regionsData,
  departements: departementsData,
} as const;

/**
 * Layer styles
 */
export const LAYER_STYLES = {
  isochrone: {
    color: '#3388ff',
    weight: 2,
    opacity: 0.8,
    fillColor: '#3388ff',
    fillOpacity: 0.2,
  },
  region: {
    color: '#e74c3c',
    weight: 2,
    opacity: 0.8,
    fillOpacity: 0.05,
    fillColor: '#e74c3c',
  },
  department: {
    color: '#3498db',
    weight: 1.5,
    opacity: 0.7,
    fillOpacity: 0.03,
    fillColor: '#3498db',
  },
} as const;

/**
 * Local storage keys
 */
export const STORAGE_KEYS = {
  typeColors: 'grist-map-colors',
} as const;

/**
 * Default isochrone configuration
 */
export const DEFAULT_ISO_CONFIG = {
  method: 'time' as const,
  graph: 'Voiture' as const,
  value: 15,
};

/**
 * Isochrone value defaults by method
 */
export const ISO_VALUE_DEFAULTS = {
  time: { value: 15, unit: 'min' },
  distance: { value: 10, unit: 'km' },
} as const;
